import {GalleryDotsPagination} from "./GalleryDotsPagination";
import {GallerySwipeOnboardingHint} from "./GallerySwipeOnboardingHint";

interface IProps {
    activeIndex: number;
    slidesCount: number;
    shouldShowDots: boolean;
    shouldShowOnboarding: boolean;
    dotsClassName?: string;
}

export const InlineGalleryOverlays = (props: IProps) => {
    const {activeIndex, dotsClassName, slidesCount, shouldShowDots, shouldShowOnboarding} = props;

    return (
        <>
            {shouldShowDots && <GalleryDotsPagination activeIndex={activeIndex} className={dotsClassName} slidesCount={slidesCount} />}
            <GallerySwipeOnboardingHint visible={shouldShowOnboarding} />
        </>
    );
};
import {GalleryDotsPagination} from "./GalleryDotsPagination";
import {GallerySwipeOnboardingHint} from "./GallerySwipeOnboardingHint";

interface IProps {
    activeIndex: number;
    slidesCount: number;
    shouldShowDots: boolean;
    shouldShowOnboarding: boolean;
    dotsClassName?: string;
}

export const InlineGalleryOverlays = (props: IProps) => {
    const {activeIndex, dotsClassName, slidesCount, shouldShowDots, shouldShowOnboarding} = props;

    return (
        <>
            {shouldShowDots && <GalleryDotsPagination activeIndex={activeIndex} className={dotsClassName} slidesCount={slidesCount} />}
            <GallerySwipeOnboardingHint visible={shouldShowOnboarding} />
        </>
    );
};
